import { BaseModel } from "sjs-base-model";

export default class InfoEstimatesModel extends BaseModel {
    public readonly idEstimate?: number = 0;
    public readonly idEstimateRequest?: number = 0;
    public readonly idDossier?: number = 0;
    public readonly idRequestType?: number = 0;
    public readonly requestType?: string = "";
    public readonly administrativeCategory?: string = "";
    public readonly agentFullName?: string = "";
    public readonly installment?: number = 0;
    public readonly duration?: number = 0;
    public readonly futureValue?: number = 0;
    public readonly commissions?: number = 0;
    public readonly balance?: number = 0;
    public readonly customerName?: string = "";
    public readonly customerSurname?: string = "";
    public readonly fiscalCode?: string = "";

    constructor(data: Partial<InfoEstimatesModel>) {
        super();

        this.update(data);
    }
}
